"use strict";

require("core-js/modules/es.object.keys.js");

require("core-js/modules/es.array.index-of.js");

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.object.assign.js");

require("core-js/modules/es.object.define-property.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.RocheMenuItem = void 0;

var _react = _interopRequireDefault(require("react"));

var _MenuItem = _interopRequireDefault(require("@material-ui/core/MenuItem"));

var _core = require("../core");

var _utils = require("../utils");

var _menuItem = require("./menu-item.styles");

var _excluded = ["classes", "button"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var RocheMenuItem = /*#__PURE__*/_react["default"].forwardRef(function (_ref, ref) {
  var classes = _ref.classes,
      button = _ref.button,
      rest = _objectWithoutProperties(_ref, _excluded);

  var innerClasses = (0, _utils.mergeClasses)((0, _menuItem.useStyles)(), classes);
  var listItemClasses = (0, _menuItem.useListItemStyles)();
  return /*#__PURE__*/_react["default"].createElement(_MenuItem["default"], _extends({
    classes: innerClasses,
    ListItemClasses: listItemClasses,
    // See Note 1
    button: button
    /*See Note 2*/
    ,
    ref: ref
  }, rest));
});

exports.RocheMenuItem = RocheMenuItem;
RocheMenuItem.displayName = (0, _core.rochePrefix)('MenuItem');
RocheMenuItem.defaultProps = {
  button: true
};
var _default = RocheMenuItem;
/**
 * NOTE 1: ListItemClasses is as prop of MenuItem, but typings are failing for whatever reason. So,
 * instead of extending the props with something that it already has, we leverage the prop this way
 * to the original component, avoiding TS throw a typing error.
 *
 * NOTE 2: button property is not well typed in MUI types.
 */

exports["default"] = _default;